<template>
  <div class="intro-card">
    <img
      class="card-image"
      :src="card.image"
      :alt="card.title"
      loading="lazy"
    />
    <h4 class="title">{{ card.title }}</h4>
    <p class="description">
      {{ card.description }}
    </p>
  </div>
</template>

<script>
export default {
  props: ["card"],
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_variables.scss";
@import "@/assets/style/_mixins.scss";
.intro-card {
  text-align: left;
  .card-image {
    border-radius: 1rem;
  }
  .title {
    color: #0b0a1c;
    margin-top: 1.1rem;
    font-weight: 500;
    font-size: 1.6rem;
    font-family: $font-poppins;
    @include tablet-down {
      font-size: 1.4rem;
    }
  }
  .description {
    color: #545460;
    font-weight: 300;
    font-family: $font-poppins;
    font-size: 1.3rem;
    line-height: 1.9rem;
    @include tablet-down {
      font-size: 1.1rem;
      line-height: 1.6rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bootcamp/enroll/intro/IntroCard.vue